<template>
  <el-carousel :interval="3000" type="card" :autoplay="true">
    <el-carousel-item v-for="(instantItem, idx) in instantList" :key="idx" class="carousel_item">
      <div class="content">
        <img :src="instantItem.img" />
        <div class="text_wrapper">
          <!-- <div class="title">
            金融聚力 智造向新
          </div> -->
          <div class="text">
            {{ instantItem.remark }}
          </div>
        </div>
      </div>

    </el-carousel-item>
  </el-carousel>
</template>

<script>
import instantCarouselImage1 from "@/assets/img/jinju-2024/instant_carousel_1.jpg";
import instantCarouselImage2 from "@/assets/img/jinju-2024/instant_carousel_2.jpg";
import instantCarouselImage3 from "@/assets/img/jinju-2024/instant_carousel_3.jpg";
import instantCarouselImage4 from "@/assets/img/jinju-2024/instant_carousel_4.jpg";
import instantCarouselImage5 from "@/assets/img/jinju-2024/instant_carousel_5.jpg";

export default {
  data() {
    return {
      instantList: [
        { img: instantCarouselImage1, remark: "国创会副会长、中国科学院大学教授吕本富" },
        { img: instantCarouselImage2, remark: "国创会学术委员会常务副主席、原中央党校副校长李君如" },
        { img: instantCarouselImage3, remark: "国创会学术委员会常务副主席、重庆市原市长黄奇帆" },
        { img: instantCarouselImage4, remark: "趣丸科技副总裁任少峰" },
        { img: instantCarouselImage5, remark: "粤开证券首席经济学家、研究院院长罗志恒" },
      ],
    }
  },

}
</script>

<style lang="scss" scoped>
.carousel_item {
  display: flex;
  justify-content: center;
  align-items: center;

  ::v-deep {
    .el-carousel__mask {
      z-index: 3;
    }
  }
}

.content {
  margin: 0 auto;
  width: 420px;
  height: 100%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .text_wrapper {
    position: absolute;
    padding-top: 10px;
    padding-left: 18px;
    padding-bottom: 10px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);

    .title {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 24px;
    }

    .text {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #D9D9D9;
      line-height: 22px;
    }
  }

}
</style>
